<template>
  <div class="main-body">
    <div class="header">查房记录</div>
    <div class="out">

      <div class="search2">
        <el-button type="primary" size="mini" plain @click.native="toggleModalAdd">添加</el-button>

        <div style="float:right">

          <el-select v-model="institutionCode" placeholder="请选择机构">
            <el-option
                v-for="item in arr_ins"
                :key="item.institutionCode"
                :label="item.userName"
                :value="item.institutionCode">
            </el-option>
          </el-select>

          <el-button style="margin-left:10px;" size="mini" type="primary" plain icon="el-icon-search" @click="getList">搜索</el-button>
        </div>
        <div style="clear: both;"></div>
      </div>


      <el-table class="table" size="mini" :data="tableData" v-loading="loading" :height="th" border>

        <el-table-column prop="elderlyName" label="残疾人"></el-table-column>
        <el-table-column prop="remarks" label="备注"></el-table-column>

        <el-table-column prop="time" label="时间"></el-table-column>
        <el-table-column prop="time" label="查房人">
          <template slot-scope="scope">
            <span v-if="scope.row.recordType == 'mediciner' ">医生[{{scope.row.medicinerName}}]</span>
            <span v-if="scope.row.recordType == 'nurse' ">护士[{{scope.row.nurseName}}]</span>
            <span v-if="scope.row.recordType == 'nurseAide' ">护工[{{scope.row.nurseAideName}}]</span>
            <span v-if="scope.row.recordType == 'institution' ">机构</span>
          </template>
        </el-table-column>

        <el-table-column fixed="right" label="操作" width="100" >
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="deleteOrder(scope.row)">删除</el-button>
          </template>
        </el-table-column>

      </el-table>

      <div class="page">
        <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
        <div style="float: left;">
          <el-pagination small
              background
              layout="prev, pager, next"
              :total="totalItems"
              :page-size="20"
              @current-change="current_change">
          </el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>

    </div>


    <Add ref="myAdd" v-show="showModalAdd" v-bind:arr_ins="arr_ins"
         v-on:closeAdd="closeAdd" v-on:getList="getList"></Add>


  </div>
</template>

<script>

import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";

import Add from "./Add";


export default {
  name: "Role",
  data(){
    return{
      loading:false,

      showModalAdd:false,


      tableData:[],
      totalItems: 0,
      pageSize:20,
      currentPage:1,

      th:0,


      arr_ins:[],
      institutionCode: '',
      type:1,


    }
  },
  components:{
    Add,
  },
  created(){
    this.getIns();

    this.th = this.$store.state.tableHeight;
  },

  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      this.th = val;
    },
  },
  methods:{

    getIns(){

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Institution/ListType",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          type:this.type,
        }
      }).then((response) => {

        if (response.data.error === 0) {
          this.arr_ins = response.data.data.list;
          if(this.arr_ins.length>0){
            this.institutionCode = this.arr_ins[0].institutionCode;
            this.getList();
          }
        }else if(response.data.error === 1){
          this.$message.error(response.data.message)
        }

      })

    },


    current_change:function(currentPage){
      this.currentPage = currentPage;
      this.getList();
    },
    getList(){
      this.loading=true;

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"CheckWardRecord/GovPageIns",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          institutionCode:this.institutionCode,
          pageIndex:this.currentPage,
          pageSize:this.pageSize,
        }
      }).then( (response)=> {
        this.loading = false;

        if(response.data.error == 0){
          this.tableData = response.data.data.list;
          this.totalItems = response.data.data.total;
        }else if(response.data.error == 1){
          this.$message({type: 'info', message: response.data.message});
        }
      }).catch(function (error) {
        console.log(error);
      });
    },

    toggleModalAdd:function(){
      this.showModalAdd = !this.showModalAdd;
      this.$refs.myAdd.init(this.type);
    },
    closeAdd:function(){
      this.showModalAdd = !this.showModalAdd;
    },


    deleteOrder(row){
      this.$confirm('是否删除此记录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {

        this.$axios({
          method: 'post',
          url: this.$shopUrl + "CheckWardRecord/Delete",
          data: {
            timeStr: timeStr,
            sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
            staffCode: getStaffCode(),
            checkWardRecordCode:row.checkWardRecordCode,
          }
        }).then((response) => {
          if (response.data.error == 0) {
            this.getList()
          } else if (response.data.error == 1) {
            this.$message({type: 'error', message: response.data.message});
          }
        }).catch(function (error) {
          console.log(error);
        });

      }).catch(() => {

      });
    },



  }
}
</script>

<style scoped>

</style>
